module.exports = __webpack_public_path__ + "img/tuopu-a.d8cc4c8a.png";